
/**
 * ForEach for looping through nodeLists
 */
function forEach(array, callback, scope) {
    for (let i = 0; i < array.length; i++) {
        callback.call(scope, i, array[i]); // passes back stuff we need
    }
}



// WEBPACK FOOTER //
// ./src/js/helpers/foreach.js